import savedSearch from './saved-search/savedSearch.directive';
import twpRefineBar from './filters/twpRefinebar';
import advancedSearch from './advanced-search/advancedSearch';
import searchPlans from './plans/searchPlans';

const toLoad = [
  savedSearch,
  twpRefineBar,
  advancedSearch,
  searchPlans
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
